import {
  AnketaAuthUser,
  AnketaCheckPermissionOptions,
  AnketaResources,
  AnketaRolesWithPermissions,
} from "../types";
import { getOrgAttributeFlags, hasPermission } from "./check-permissions";

/**
 * May this user run an opsanio action? The UI mirror of the server rule.
 *
 * Every opsanio route checks the internal-org gate and then the matrix
 * (`getOpsanioFeatureAccess` / `extractToken`), with the superuser bypass in
 * front. So: superuser, or (internal org AND matrix grant for resource ·
 * action, narrowed by `options`). Drives affordances only - the server stays
 * the boundary.
 */
export const opsanioCan = (
  user: AnketaAuthUser | undefined,
  resource: AnketaResources,
  action: string,
  options?: AnketaCheckPermissionOptions<AnketaResources>,
  matrix?: AnketaRolesWithPermissions,
): boolean => {
  if (!user) return false;
  if (user.isSudo) return true;
  if (!getOrgAttributeFlags(user).isInternal) return false;
  return hasPermission(user, resource as any, action as any, options, matrix);
};
